import React from "react";
import ButtonGroup from "./ButtonGroup";
import { CATEGORIES, PROFESSIONAL_FIELDS } from "../utils/formConstants";

// The kind of room and, for a professional room, its field (GIS-305). The v2 web
// app files rooms under Friends or Professionals by `category`, lists
// professional rooms by `field`, and never lists dating rooms. A field only
// means something on a professional room, so switching away clears it.
const RoomKindInput = ({ category, field, onChange }) => (
  <div className="space-y-4">
    <ButtonGroup
      buttons={CATEGORIES}
      defaultSelected={category}
      onSelected={(option) => {
        onChange("category", option.id);
        if (option.id !== "professional") onChange("field", null);
      }}
      label="Kind of room"
    />
    {category === "professional" && (
      <div className="space-y-2 max-w-md">
        <label
          htmlFor="event-field"
          className="block text-sm font-medium text-gray-500 dark:text-gray-400"
        >
          Field
        </label>
        <select
          id="event-field"
          value={field || ""}
          onChange={(e) => onChange("field", e.target.value || null)}
          className="block text-gray-700 dark:text-gray-200 w-full rounded-md border-gray-300 dark:border-gray-600 dark:bg-gray-800 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
        >
          <option value="">Pick a field</option>
          {PROFESSIONAL_FIELDS.map((option) => (
            <option key={option.id} value={option.id}>
              {option.label}
            </option>
          ))}
        </select>
        <p className="text-xs text-gray-500 dark:text-gray-400">
          Members in the app browse professional rooms by field.
        </p>
      </div>
    )}
  </div>
);

export default RoomKindInput;
